import { ProgressState } from '@axo/ui-core/components/ProgressIndicator';

export const getStepState = (step: number, current: number): ProgressState =>
  step < current ? 'completed' : step === current ? 'active' : 'untouched';
